module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CT-71d1cb350d4d1cfc1329a78e7f40a812.png";